import {
	UPDATE_AVALIACOES,
	AVALIACOES_REQUEST,
} from './types';

export const updateAvaliacoes = (field, value) => ({ type: UPDATE_AVALIACOES, field, value });
export const getAvaliacoes = (page = 1, fornecedor = null) => ({ type: AVALIACOES_REQUEST, fornecedor, page });
